/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HashicorpCloudInfragraph20250507Source = {
    Unknown: 'UNKNOWN',
    Aws: 'AWS',
    Packer: 'PACKER',
    Azure: 'AZURE'
};
export function instanceOfHashicorpCloudInfragraph20250507Source(value) {
    for (const key in HashicorpCloudInfragraph20250507Source) {
        if (Object.prototype.hasOwnProperty.call(HashicorpCloudInfragraph20250507Source, key)) {
            if (HashicorpCloudInfragraph20250507Source[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function HashicorpCloudInfragraph20250507SourceFromJSON(json) {
    return HashicorpCloudInfragraph20250507SourceFromJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507SourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudInfragraph20250507SourceToJSON(value) {
    return value;
}
export function HashicorpCloudInfragraph20250507SourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
